import {
    forwardRef,
    memo,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from 'react';
import InputModal from '../input-modal/InputModal';
import styles from './Select2.module.scss';
import clsx from 'clsx';

function Select(
    { name, options, intiSelectedIndex, title, addNew, markdown, onChange },
    ref,
) {
    const [showInputModal, setShowInputModal] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(
        intiSelectedIndex >= 0 ? intiSelectedIndex : 0,
    );
    const listRef = useRef(null);

    const handleClickAnswer = () => {
        setShowOptions(!showOptions);
    };

    const handleAddNew = () => {
        setShowInputModal(true);
    };

    const handleClickItem = (index) => () => {
        if (index !== selectedIndex) {
            setSelectedIndex(index);
            // console.log('name', name);
            onChange(index, name);
        }
        setShowOptions(!showOptions);
    };

    useEffect(() => {
        if (listRef && listRef.current) {
            let index = selectedIndex - 1 < 0 ? 0 : selectedIndex - 1;
            const ele = listRef.current.children[index];
            if (ele) ele.scrollIntoView();
        }
    }, [selectedIndex, showOptions]);

    const onCancel = () => {
        setShowInputModal(false);
    };

    const onSave = () => {
        setShowInputModal(false);
        setShowOptions(!showOptions);
        setSelectedIndex(0);
    };

    useImperativeHandle(ref, () => ({
        changeSelectedIndex(index) {
            if (index < 0 || index > options.length - 1) return;
            setSelectedIndex(index);
        },
    }));
    // console.log('re-render Select');
    return (
        <>
            <div className={styles.wrapper}>
                {title && <div className={styles.title}>{title}</div>}
                <div className={styles.answer} onClick={handleClickAnswer}>
                    {options.length > 0 && options[selectedIndex].icon && (
                        <div className={styles.icon}>
                            {options[selectedIndex].icon}
                        </div>
                    )}
                    {options.length > 0 && (
                        <div className={styles.content}>
                            {options[selectedIndex].name}
                        </div>
                    )}
                </div>
                {showOptions && (
                    <div
                        className={styles.modal}
                        onClick={handleClickAnswer}
                    ></div>
                )}
                {showOptions && (
                    <ul className={styles.options} ref={listRef}>
                        {addNew && (
                            <li
                                key={'addNew'}
                                className={clsx(styles.item, styles.addNew)}
                                onClick={handleAddNew}
                            >
                                <div className={styles.content}>Thêm mới</div>
                            </li>
                        )}
                        {options.map((option, index) => (
                            <li
                                key={option.name}
                                className={styles.item}
                                onClick={handleClickItem(index)}
                            >
                                {option.icon && (
                                    <div className={styles.icon}>
                                        {option.icon}
                                    </div>
                                )}
                                <div className={styles.content}>
                                    {option.name}
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                {markdown && (
                    <div
                        className={styles.markdown}
                        onClick={handleClickAnswer}
                    >
                        {showOptions ? (
                            <i className="fa-solid fa-angle-up"></i>
                        ) : (
                            <i className="fa-solid fa-angle-down"></i>
                        )}
                    </div>
                )}
            </div>
            {showInputModal && (
                <InputModal onCancel={onCancel} onSave={onSave}></InputModal>
            )}
        </>
    );
}

export default memo(forwardRef(Select));
